import { IRoute, ICrudRoute } from '@interfaces/App.interface';
import { generateCRUDRoutes } from './routes.utils';
import DistributionListPage from '@pages/DataBase/Configuration/Distributions/DistributionListsPage';
import DistributionConfigPage from '@pages/DataBase/Configuration/Distributions/DistributionConfigurationPage';
import LabelPage from '@pages/DataBase/Configuration/Labels/LabelPage';
import UniqueIdSeriePage from '@pages/DataBase/Configuration/UniqueIDSeries/UniqueIdSeriePage';
import Warnings from '@pages/DataBase/Warnings/Warnings';

//#region CRUD
const crudEntitiesData: ICrudRoute[] = [
  //TAG Labels
  { aclId: 'tag', entityName: 'tag', DataTable: null, FormPage: LabelPage },
  //DistributionConfiguration
  {
    aclId: 'DistConf',
    entityName: 'distributionConfiguration',
    DataTable: null,
    FormPage: DistributionConfigPage,
    customId: { new: 'distConfigNew', edit: 'distConfigEdit', view: 'distConfigView' },
  },
  //DistributionList
  {
    aclId: 'DistList',
    entityName: 'distributionList',
    DataTable: null,
    FormPage: DistributionListPage,
    customId: { new: 'distListNew', edit: 'distListEdit', view: 'distListView' },
  },
  //Notification
  { aclId: 'taNotification', entityName: 'notification', DataTable: null, FormPage: null },
  //UniqueIdSeries
  { aclId: 'UniqueNumSerie', entityName: 'uniqueIdSerie', DataTable: null, FormPage: UniqueIdSeriePage },
];
//#endregion

//#region Configuration
const configRoutes: IRoute[] = [
  //Notifications
  {
    id: 'warnings',
    matchPath: '/warnings/:tab?',
    pageComponent: Warnings,
    pageTitle: 'Warnings',
    aclId: 'taNotification',
    canFilter: true,
  },
];
//#endregion

export default [...configRoutes, ...generateCRUDRoutes(crudEntitiesData)];
